import LegalLayout, { COMPANY, EMAIL } from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Política de Cookies">
      <p>Esta política explica cómo {COMPANY} usa cookies y tecnologías similares en la plataforma Hephy 3D.</p>

      <h2>¿Qué son las cookies?</h2>
      <p>Son pequeños archivos que se guardan en tu dispositivo para recordar información entre sesiones.</p>

      <h2>Cookies que usamos</h2>
      <ul>
        <li><b>Esenciales:</b> autenticación y sesión (necesarias para iniciar sesión y usar el panel). Usamos almacenamiento local del navegador para tu token de sesión.</li>
        <li><b>Funcionales:</b> preferencias de la interfaz y del personalizador 3D.</li>
        <li><b>Terceros:</b> Stripe puede establecer cookies necesarias para procesar pagos de forma segura.</li>
      </ul>
      <p>No utilizamos cookies publicitarias ni de seguimiento de terceros con fines de marketing.</p>

      <h2>Cómo controlarlas</h2>
      <p>Puedes borrar o bloquear cookies desde la configuración de tu navegador. Ten en cuenta que deshabilitar las cookies esenciales impedirá el inicio de sesión.</p>

      <h2>Contacto</h2>
      <p>{COMPANY} — <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>
    </LegalLayout>
  );
}
